/**
 * Created by Christof Sander on 27.05.2016.
 */

// const CONSTANTS = require('../../lib/constants');
const utils     = require('../../lib/utils');

module.exports = {
	methods: {
		sanitizeModelFields: function(storage){
			this.postResourcePreload(storage);
		},

		postResourcePreload: function(storage){
			// do not try to sanitize empty data
			if(!this.model.routes || utils.isEmpty(this.model.routes.options) || !Array.isArray(this.model.routes.options)) return;

			// init
			var deletionIndex = 0;
			var routes = this.model.routes.options;

			utils.forEach(routes, function(option, optionIndex) {
				// status check
				if (
					!!(
						(
							storage.user
							&&
							utils.isFunction(storage.user.statusVisible)
							&&
							storage.user.statusVisible(option.status)
						)
						||
						(
							(
								utils.isEmpty(option.status)
								||
								option.status === 'active'
								||
								option.status === 'preview & active'
								||
								option.status === 'invisible'
							)
						)
					)
					&&
					// period check
					(
						(
							!option.periodStart
							||
							storage.user.getReferenceTS() >= option.periodStart
						)
						&&
						(
							!option.periodEnd
							||
							storage.user.getReferenceTS() <= option.periodEnd
						)
					)
				) {
					// reset potentially cached entries
					delete routes[optionIndex].options;
				} else {
					routes.splice(parseInt(optionIndex) + deletionIndex, 1);
					deletionIndex++;
				}
			});

			// for all children
			routes.forEach(function(childRoute, childRouteIndex){
				// look for parent
				routes.forEach(function(parentRoute, parentRouteIndex) {
					// parent found?
					if(parentRoute.routeID == childRoute.parentRouteID){
						// set child within parent list and set child reference in list-root-level
						if(routes[parentRouteIndex].options == undefined){
							routes[parentRouteIndex].options = [];
						}
						var child = utils.simpleCopy(childRoute);
						child.parentRouteFound = true;
						routes[parentRouteIndex].options.push(child);
						routes[childRouteIndex] = routes[parentRouteIndex].options[(routes[parentRouteIndex].options.length - 1)];
						return false;
					}
				});
			});

			// delete route-nodes in list-root-level having a parent
			var deletions = 0;
			utils.forEach(routes, function(route, routeIndex){
				if(routes[routeIndex - deletions].parentRouteFound){
					routes.splice(routeIndex - deletions, 1);
					deletions++;
				}
			});
		}
	}
};